import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { UpsellLayout } from '../../../layouts/mainMenu/shop/UpsellLayout';
import type { IAPProduct } from '../../app/iap/types';
import { InventoryItem } from '../../app/resources/types';
import { setIconForInventory } from './utils/setIconForInventory';
import { setTextAsTimerCountdown } from '../../utils/pixi/setTextAsTimerCountdown';

export interface UpsellCatalog {
  coinOffer: IAPProduct;
  specialOffer: IAPProduct;
}

export class UpsellInventoryView extends Container {
  public onItemClicked = new Signal<(productId: IAPProduct) => void>();

  private readonly layout = new UpsellLayout();

  constructor(private readonly config: UpsellCatalog) {
    super();
    this.init();
  }

  private init(): void {
    const {
      layout: { root },
      config: { coinOffer, specialOffer },
    } = this;

    root.props({
      parent: this,
    });

    this.initCoinOffer(coinOffer);
    this.initUpsellOffer(specialOffer);
  }

  private initCoinOffer(product: IAPProduct): void {
    const { coinOfferAmount, coinOfferPrice, coinOffer } = this.layout;

    coinOffer.on('pointertap', () => {
      this.onItemClicked.emit(product);
    });

    const coinsAmount = product.rewards.Coin;
    coinOfferAmount.text = coinsAmount ?? '???';
    coinOfferPrice.text = product.priceLabel;
  }

  private initUpsellOffer(product: IAPProduct): void {
    const {
      layout: {
        upsellCountdown,
        upsellItemIcon,
        upsellItemAmount,
        upsellItemContainer,
        upsellOfferCoinsAmount,
        upsellOfferPrice,
        upsellOffer,
      },
    } = this;

    upsellOffer.on('pointertap', () => {
      this.onItemClicked.emit(product);
    });

    const coinsAmount = product.rewards.Coin;
    upsellOfferCoinsAmount.text = coinsAmount ?? '???';
    upsellOfferPrice.text = product.priceLabel;

    const items = (Object.entries(product.rewards) as [InventoryItem, number][]).filter(
      ([item]) => item !== InventoryItem.Coin,
    );

    upsellItemContainer.forEach((container, index) => {
      const itemEntry = items[index];
      if (!itemEntry) {
        container.visible = false;
        return;
      }

      const [item, amount] = itemEntry;
      setIconForInventory(upsellItemIcon[index], item);
      upsellItemAmount[index].text = `x${amount}`;
    });

    setTextAsTimerCountdown(upsellCountdown, this.config.specialOffer.endDate ?? Date.now());
  }
}
